import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CartService, GaService, OrderService, ProductService } from '../../../../services';
import * as CartStore from '../../../../store/cart';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { BaseComponent, ORDER_BY_VALUE } from 'src/app/core';
import { Cart, CartListDto } from '../../../../dto';
import { SELECT_PRODUCT_STORE_NAME } from 'src/app/store/select-product';
import { Location } from '@angular/common';

@Component({
  selector: 'app-my-cart',
  templateUrl: './my-cart.component.html',
  styleUrls: ['./my-cart.component.scss'],
  standalone: false,
})
export class MyCartComponent extends BaseComponent implements OnInit, OnDestroy {
  private cartService = inject(CartService);
  private router = inject(Router);
  private orderService = inject(OrderService);
  private productServcie = inject(ProductService);
  private gaService = inject(GaService);

  cartCounts = 0;

  carts: Cart[];

  total = { summary: 0, quantity: 0 };
  cartLayer = false;
  isCartPage = false;

  constructor() {
    super();
    this.store
      .select(CartStore.CART_STORE_NAME)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((state) => {
        this.getCart();
      });
  }

  ngOnInit() {
    if (location.pathname === '/cart') {
      this.isCartPage = true;
    }
  }

  override ngOnDestroy(): void {
    this.isAlive = false;
  }

  getCart() {
    this.cartService
      .getCartItems(new CartListDto().setSort(CartService.ORDER_BY[0].value, ORDER_BY_VALUE[1]))
      .subscribe((paginatedCart) => {
        this.carts = paginatedCart.items && paginatedCart.items.map((item) => new Cart(item));
        this.productServcie.cartsProductLength = this.carts.length;
        this.caculateSummaryTotal();
      });
  }

  goToCart() {
    if (this.router.url !== '/cart') {
      this.gaService.logClickCart(this.cartCounts);
      this.router.navigateByUrl('/cart');
    }
  }

  caculateSummaryTotal() {
    this.total = this.orderService.caculateCartsTotal(this.carts);
  }
}
